// extracted by mini-css-extract-plugin
export default {"news_box":"index_news_box_vXDGr clearfix","box_r":"index_box_r_IQR7f","d_box":"index_d_box_4ARVo"};